import styled from "styled-components";

interface ComponentProps {
  children: any;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  height: 100%;
  min-height: 780px;
  margin-left: 1px;
  border-left: 1px solid ${(props) => props.theme.colors.border};

  @media screen and (max-width: 850px) {
    border-left: none;
    width: 100%;
  }
`;

const MainInformations: React.FC<ComponentProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default MainInformations;
